<template>
  <div class="container DCDetail">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('DC.DCDetail')" name="1">
        <div class="searchBox_top">
          <el-button class="btn" size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        </div>
        <div class="info_box_father">
          <div class="box">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">Basic Information</p>
            </div>
            <el-form :model="DetailForm" ref="DetailForm" label-width="180px">
              <el-row>
                <el-col :span="8">
                  <!-- DCNumber字段由MDM进行编辑，供应商不可编辑。 -->
                  <!-- DC编码 -->
                  <el-form-item :label="$t('DC.DCNumber')" prop="supplierCode">
                    <el-input v-model.trim="DetailForm.supplierCode" maxlength="20" clearable disabled></el-input>
                  </el-form-item>
                </el-col>
                <!-- 状态 -->
                <el-col :span="8">
                  <el-form-item :label="$t('common.status')" prop="status">
                    <ic-select table="TM_SUPPLIER" field="START_STATE" disabled v-model="DetailForm.status"></ic-select>
                  </el-form-item>
                </el-col>
                <!-- 创建日期 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.createDate')" prop="createDate">
                    <el-date-picker v-model="DetailForm.createDate" type="date" value-format="yyyy-MM-dd" disabled :placeholder="$t('common.selDate')"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- DC名称 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.supplierName')" prop="supplierNameShort">
                    <el-input v-model="DetailForm.supplierNameShort" maxlength="33" disabled></el-input>
                  </el-form-item>
                </el-col>
                <!-- DC简称 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.supplierNameShort')" prop="supplierName">
                    <el-input v-model="DetailForm.supplierName" maxlength="33" disabled></el-input>
                  </el-form-item>
                </el-col>
                <!-- DC类型 -->
                <!-- DC type由供应商、SS进行编辑 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.DCType')" prop="dctype">
                    <ic-select clearable table="TM_SUPPLIER" field="DC_TYPE" disabled v-model="DetailForm.dctype"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="国家" prop="country">
                    <el-select v-model="DetailForm.country" placeholder="请选择" disabled>
                      <el-option clearable v-for="item in countryList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省份" prop="province">
                    <el-select v-model="DetailForm.province" placeholder="请选择" disabled>
                      <el-option clearable v-for="item in provinceList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="市/县" prop="city">
                    <el-select v-model="DetailForm.city" placeholder="请选择" disabled>
                      <el-option clearable v-for="item in cityList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- 市/区 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.tmAreaId')" prop="tmAreaId">
                    <el-select v-model="DetailForm.tmAreaId" placeholder="请选择" disabled>
                      <el-option clearable v-for="item in AreaList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 详细地址 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.address')" prop="address">
                    <el-input v-model.trim="DetailForm.address" maxlength="33" disabled></el-input>
                  </el-form-item>
                </el-col>
                <!-- 邮政编码 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.postCode')" prop="postCode">
                    <el-input v-model="DetailForm.postCode" disabled maxLength='6'></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="联系人" prop="linkman">
                    <el-input v-model="DetailForm.linkman" maxlength="20" disabled></el-input>
                  </el-form-item>
                </el-col>
                <!-- 手机号 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.telephoneNo')" prop="telephoneNo">
                    <el-input v-model="DetailForm.telephoneNo" disabled maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 邮箱 -->
                <el-col :span="8">
                  <el-form-item :label="$t('DC.emailAddress')" prop="emailAddress">
                    <el-input v-model="DetailForm.emailAddress" maxlength="50" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- 备注 -->
                <el-col :span="24">
                  <el-form-item :label="$t('common.remarks')" prop="description">
                    <el-input v-model="DetailForm.description" maxlength="33" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="box" v-if="emplFlag != 'SUP'">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">ADP</p>
            </div>
            <el-table :data="fpaLogisticRates" max-height="500" ref="fpaLogisticRates" border highlight-current-row style="margin-top: 10px ;" class="campaign_table PQCP">
              <el-table-column align="center" label="Transportation">
                <el-table-column align="center" prop="transportationRate" label="New Item Rate without VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationRate | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationRateWithVat | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVat" label="VAT Rate" show-overflow-tooltip min-width="100">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationVat | toPercent}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="transportationVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.transportationVatValue | fix(6) }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" label="Warehouse">
                <el-table-column align="center" prop="warehouseRate" label="New Item Rate without VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseRate | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseRateWithVat" label="New Item Rate with VAT" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseRateWithVat | fix(6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVat" label="VAT Rate" show-overflow-tooltip min-width="100">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseVat | toPercent}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="warehouseVatValue" label="New Item VAT Value" show-overflow-tooltip min-width="180">
                  <template slot-scope="scope">
                    <span>{{scope.row.warehouseVatValue | fix(6) }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" prop="adpCost" label="Total ADP Cost(without VAT)" show-overflow-tooltip min-width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.adpCost | fix(6) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="adpCostWithVat" label="Total ADP Cost(with VAT)" show-overflow-tooltip min-width="180">
                <template slot-scope="scope">
                  <span>{{scope.row.adpCostWithVat | fix(6) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box" v-if="emplFlag != 'SUP'">
            <div class="info_box_title">
              <p class="line"></p>
              <p class="info_title">Planning Service</p>
            </div>
            <el-form ref="listForm" :model="listForm">
              <el-row>
                <el-col :span="9">
                  <el-form-item label="Agreed Price(price/case or tray in RMB with VAT)" prop="agreedPriceWithVat" label-width="290px">
                    <el-input v-model="listForm.agreedPriceWithVat" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="per" prop="agreedPriceWithVatUnit" label-width="60px">
                    <el-input v-model="listForm.agreedPriceWithVatUnit" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="Agreed Price(price/case or tray in RMB without VAT)" prop="agreedPrice" label-width="300px">
                    <el-input disabled v-model="listForm.agreedPrice" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="per" prop="agreedPriceUnit" label-width="60px">
                    <el-input v-model="listForm.agreedPriceUnit" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="VAT Rate" prop="settleVat" label-width="290px">
                    <el-input v-model="listForm.settleVat" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Settle" prop="settleDcName" label-width="300px">
                    <el-input v-model="listForm.settleDcName" style="width: 100%" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="2">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime') ">
            <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion') "></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import supplierApi from "@/api/supplier/supplier";
import DCApi from "@/api/DC/DC";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  components: { IcSelect },
  data() {
    let validaPostCode = (rule, value, callback) => {
      let that = this;
      if (!value) {
        callback(new Error(this.$t("visitPlan.noEmpty")));
      } else if (value.length < 6) {
        callback(new Error('长度不符合要求'));
      } else {
        callback();
      }
    };
    return {
      isSave: true,
      isSubmit: true,
      isExamine: false,
      tempAddress: '',
      currentTab: '1',
      id: '',
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      auditLog: [],//审批日志
      DetailForm: {
        dctype: '',
        supplierName: '',
        emailAddress: '',
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
        telephoneNo: '',
        address: '',
        postCode: '',
        futureEffectiveDate: '',
        status: 1,
        linkman: '',
        createDate: this.$options.filters["dateFormatFilter"](new Date()),
      },
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      auditStatus: '',
      emplFlag: '',
      emplFlag2: '',
      SSlogistic: false,
      fpaLogisticRates: [],
      listForm: {
        agreedPrice: "",
        agreedPriceUnit: "",
        agreedPriceWithVat: "",
        agreedPriceWithVatUnit: "",
        settleDcName: "",
        settleVat: "",
        settleVatValue: "",
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id)
      this.id = this.$route.query.id
    }
    this.getArea()
    //用户所属系统(SUP供应商)
    const emplFlag = localStorage.getItem("ms_emplFlag");
    console.log(emplFlag)
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
        if (permission[i] == 'dc_ss_business_audit') {
          this.emplFlag2 = 'SS';
        }
      }
    }
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SS Category leader logistic') {
        this.SSlogistic = true;
      }
    }

  },
  methods: {
    getDetail(id) {
      let that = this
      DCApi.getDetail(id).then(res => {

        if (res.resultData[0].country) {
          that.countryChange(res.resultData[0].country)
          that.provinceChange(res.resultData[0].province)
          that.cityChange(res.resultData[0].city)
          Promise.all([that.countryChange(), that.provinceChange(), that.cityChange()]).then(() => {
            if (res.resultData[0].country) {
              res.resultData[0].country = parseInt(res.resultData[0].country)
              res.resultData[0].province = parseInt(res.resultData[0].province)
              res.resultData[0].city = parseInt(res.resultData[0].city)
              res.resultData[0].tmAreaId = res.resultData[0].tmAreaId
            }
          })
          console.log("🚀 ~ getDetail ~ parseInt(res.resultData[0].country):", res.resultData[0].country)
          console.log("🚀 ~ getDetail ~ parseInt(res.resultData[0].province):", res.resultData[0].province)
          console.log("🚀 ~ getDetail ~  parseInt(res.resultData[0].city):", res.resultData[0].city)
          console.log("🚀 ~ getDetail ~ that.DetailForm:", that.DetailForm)
        } else {
          res.resultData[0].country = res.resultData[0].countryTxt
          res.resultData[0].province = res.resultData[0].provinceTxt
          res.resultData[0].city = res.resultData[0].cityTxt
          res.resultData[0].tmAreaId = res.resultData[0].districtTxt
        }

        this.DetailForm = res.resultData[0]
        let dcRateInfo = res.resultData[1] ? res.resultData[1] : {};
        this.fpaLogisticRates = res.resultData[1] ? [res.resultData[1]] : []
        this.listForm.agreedPriceWithVat = dcRateInfo.agreedPriceWithVat ? dcRateInfo.agreedPriceWithVat.toFixed(6) : ''
        this.listForm.agreedPriceWithVatUnit = dcRateInfo.agreedPriceWithVatUnit
        this.listForm.agreedPrice = dcRateInfo.agreedPrice ? dcRateInfo.agreedPrice.toFixed(6) : ""
        this.listForm.agreedPriceUnit = dcRateInfo.agreedPriceUnit
        this.listForm.settleVat = dcRateInfo.settleVat ? (dcRateInfo.settleVat * 100) + '%' : dcRateInfo.settleVat == 0 ? 0 : ''
        this.listForm.settleVatValue = dcRateInfo.settleVatValue
        this.listForm.settleDcName = dcRateInfo.settleDcName
        if (this.DetailForm.adpwotax) {
          this.DetailForm.adpwotax = Number(this.DetailForm.adpwotax).toFixed(6);
        }
        if (this.DetailForm.adp) {
          this.DetailForm.adp = Number(this.DetailForm.adp).toFixed(6);
        }
        if (this.DetailForm.futureADPwotax) {
          this.DetailForm.futureADPwotax = Number(this.DetailForm.futureADPwotax).toFixed(6);
        }
        // if(this.emplFlag2 == 'SS' && res.resultData[0].isExamine){
        //     this.isSave = true
        // }
        this.auditStatus = res.resultData[0].auditStatus//1 Draft 创建 2 ongoing 进行中 3 submit 待MDM审批 4 approve 完成 5 reject 审批退回
        this.isSubmit = res.resultData[0].isSubmit
        that.isSave = res.resultData[0].isSave
        that.auditLog = res.resultData[0].workFlowLogList
        this.$nextTick(() => {
          this.isExamine = res.resultData[0].isExamine
        });
      });
    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.province = ''
        that.DetailForm.city = ''
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          that.provinceList = res.data
          console.log("🚀 ~ countryChange ~ that.provinceList :", that.provinceList)
          resolve()
        });
      })
    },
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.city = ''
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          console.log("🚀 ~ provinceChange ~ this.cityList:", this.cityList)
          resolve()
        });
      })

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        that.DetailForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          console.log("🚀 ~ cityChange ~ this.AreaList:", this.AreaList)
          resolve()
        });
      })

    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = 4484;
      attachment.tsReckindId = 'QUOTATION_APPLY';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.ttQuotationApplyId;
        attachment.tsReckindId = 'QUOTATION_APPLY';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => {
      })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    blurInput(e, prop) {
      this.DetailForm.prop = e.target.value
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    toFixedValue: function (value) {
      if (value) {
        value = Number(value).toFixed(6)
      }
    },
    oninput(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var lenLast = str.substr(str.length - 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == ".") {
        str = ""
      }
      //最后一位不能是.
      if (str.length == 8 && lenLast == ".") {
        str = ""
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1)
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = (str.match(/^\d*(\.?\d{0,6})/g)[0]) || null
      // 小数点后只能输两位
      return str
    }
  }

}
</script>
<style lang="scss" scoped>
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
}
.info_title {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  float: left;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
  float: left;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-card {
  // .el-select{
  //     width:20%;
  // }
  // .el-date-editor{
  //     width: 20%;
  // }
  // .el-input{
  //     width: 20%;
  // }
}
</style>
<style lang="scss">
.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.noLeft2 {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.flexBox {
  .el-row {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .el-radio__label {
      width: 100px;
      display: inline-block;
    }
  }
}
.DCDetail
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: "";
}
.info_box_father {
  width: calc(100% - 16px);
  padding: 0 8px;
}
.box {
  // width: 100%;
  // height: auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
  margin-bottom: 15px;
  border-radius: 8px;
  padding: 0 8px;
}
</style>
